import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { GOOGLE_MEET_OAUTH_MESSAGE_TYPE, GOOGLE_MEET_OAUTH_STORAGE_KEY } from './googleMeetOAuth'
import { AlertCircle, CheckCircle2, Copy } from 'lucide-react'
import { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'

function parseOAuthParams() {
  const params = new URLSearchParams(window.location.search)
  return {
    code: params.get('code') || '',
    error: params.get('error') || '',
    errorDescription: params.get('error_description') || ''
  }
}

const GoogleMeetCallback = () => {
  const navigate = useNavigate()
  const [copied, setCopied] = useState(false)
  const { code, error, errorDescription } = useMemo(() => parseOAuthParams(), [])

  useEffect(() => {
    if (!code) return

    try {
      localStorage.setItem(
        GOOGLE_MEET_OAUTH_STORAGE_KEY,
        JSON.stringify({
          code,
          receivedAt: Date.now()
        })
      )
    } catch {
      // Se falhar o storage, ainda segue com postMessage.
    }

    if (window.opener && !window.opener.closed) {
      window.opener.postMessage(
        {
          type: GOOGLE_MEET_OAUTH_MESSAGE_TYPE,
          code
        },
        window.location.origin
      )
    }
  }, [code])

  const handleCopyCode = async () => {
    if (!code) return
    await navigator.clipboard.writeText(code)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  const handleGoToSettings = () => {
    navigate('/configuracoes')
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-muted/20">
      <Card className="w-full max-w-xl p-6 space-y-4">
        {error ? (
          <>
            <div className="flex items-center gap-2 text-destructive">
              <AlertCircle className="h-5 w-5" />
              <h1 className="text-lg font-semibold">Falha na autorização Google</h1>
            </div>
            <p className="text-sm text-muted-foreground">
              O Google retornou um erro ao tentar autorizar a integração.
            </p>
            <Input value={error} readOnly />
            {errorDescription ? <Input value={errorDescription} readOnly /> : null}
          </>
        ) : code ? (
          <>
            <div className="flex items-center gap-2 text-emerald-600">
              <CheckCircle2 className="h-5 w-5" />
              <h1 className="text-lg font-semibold">Autorização concluída</h1>
            </div>
            <p className="text-sm text-muted-foreground">
              Código recebido e enviado para a tela de Configurações.
            </p>
            <Input value={code} readOnly />
            <div className="flex flex-col md:flex-row gap-2">
              <Button type="button" variant="outline" onClick={handleCopyCode}>
                <Copy className="mr-2 h-4 w-4" />
                {copied ? 'Código copiado' : 'Copiar código'}
              </Button>
              <Button type="button" onClick={handleGoToSettings}>
                Voltar para Configurações
              </Button>
            </div>
          </>
        ) : (
          <>
            <div className="flex items-center gap-2 text-amber-600">
              <AlertCircle className="h-5 w-5" />
              <h1 className="text-lg font-semibold">Código não encontrado</h1>
            </div>
            <p className="text-sm text-muted-foreground">
              Esta página deve ser acessada somente pelo redirecionamento OAuth do Google.
            </p>
            <Button type="button" onClick={handleGoToSettings}>
              Ir para Configurações
            </Button>
          </>
        )}
      </Card>
    </div>
  )
}

export default GoogleMeetCallback
